/* Wuschelherz: aus snippets/wh-pdp-ux.liquid ausgelagert (Perf 1, 2026-11-02). Änderungen hier, nicht im Snippet. */
  (() => {
    const mobile = window.matchMedia('(max-width: 989px)').matches;
    const info = () => document.querySelector('product-info.product__info');

    // B1: Countdown unter den Titel
    const placeCountdown = () => {
      if (!mobile) return;
      const i = info(); const title = i && i.querySelector(':scope > .product__title');
      const cd = document.querySelector('.featured-product > .product-countdown');
      if (title && cd) title.before(cd);   // gleiche Stelle wie shipping-countdown (placeDiscount), sichtbar per order unter dem Titel
    };

    // A7: Namen unter die Rahmen-Kreise
    const labelSwatches = () => {
      document.querySelectorAll('.tee-variants .tee-option--color .tee-radio-label[title]').forEach((label) => {
        const box = label.parentElement;
        if (!box || box.querySelector('.wh-swatch-name')) return;   // wh-pdp-r3 schiebt den Namen in die Kachel
        const name = document.createElement('span');
        name.className = 'wh-swatch-name';
        name.setAttribute('aria-hidden', 'true');
        name.textContent = label.getAttribute('title').replace(/\s*Rahmen$/, '').replace('Natur-Holz', 'Natur').replace('Dunkles Holz', 'Dunkel');
        box.appendChild(name);
      });
    };

    // B2: Sticky-Knopf
    let uploaded = false;
    const fileInput = () => document.querySelector('.tee-customization-wrapper input[type="file"], main input[type="file"]');
    const teeAtc = () => document.querySelector('.tee-btn--atc');
    const priceText = () => {
      const el = document.querySelector('.tee-product-price .money:not(.tee-price--compare), [id^="StickyPrice-"] .price__regular');
      return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
    };
    const stickyButtons = () => Array.from(document.querySelectorAll('product-sticky-form button[name="add"]'));
    const updateSticky = () => {
      stickyButtons().forEach((btn) => {
        if (!btn.dataset.whCta) {
          btn.dataset.whCta = '1';
          btn.type = 'button';
          btn.removeAttribute('form');
          btn.classList.add('wh-sticky-cta');
          const text = btn.querySelector('.btn-text');
          if (text) text.innerHTML = '<span class="wh-sticky-cta__label"></span>';
          btn.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (!uploaded) {
              const input = fileInput();
              const target = input ? (input.closest('.tee-form-item, .tee-photo-input, .tee-block') || input) : document.querySelector('.tee-customization-wrapper');
              if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              return;
            }
            const atc = teeAtc();
            if (atc) atc.click();
          }, true);
        }
        const label = btn.querySelector('.wh-sticky-cta__label');
        // seit Schritt 31 steht der Preis links in der Leiste, der Knopf bleibt kurz
        const wanted = uploaded ? 'In den Warenkorb' : 'Foto hochladen';
        if (label && label.textContent !== wanted) label.textContent = wanted;
        btn.setAttribute('aria-label', wanted);
      });
    };
    document.addEventListener('change', (event) => {
      const t = event.target;
      if (t instanceof HTMLInputElement && t.type === 'file' && t.files && t.files.length) { uploaded = true; updateSticky(); }
    }, true);

    // Runde 2: Preis von Teeinblue direkt unter den Titel (Platzhalter in den Produktinfos)
    const placePrice = () => {
      // seit Feinschliff 2026-10-19 auch auf dem Desktop (Preis direkt unter dem Titel)
      const i = info(); if (!i) return;
      let slot = i.querySelector(':scope > .wh-price-slot');
      if (!slot) { slot = document.createElement('div'); slot.className = 'wh-price-slot'; i.appendChild(slot); }
      const price = document.querySelector('.tee-customization-wrapper > .tee-product-price');
      if (price && price.parentElement !== slot) { slot.replaceChildren(price); }
    };
    // Runde 2: Beschreibung mobil als Akkordeon (die Vorteile stehen sonst doppelt)
    const wrapDescription = () => {
      if (!mobile) return;
      const i = info(); if (!i) return;
      const desc = i.querySelector(':scope > .product__text.rte');
      if (!desc) return;
      const box = document.createElement('details');
      box.className = 'wh-desc';
      const summary = document.createElement('summary');
      summary.textContent = 'Beschreibung';
      box.appendChild(summary);
      i.insertBefore(box, desc);
      box.appendChild(desc);
    };

    // Runde 2: Galerie-Zähler statt winziger Punkte (mobil)
    const galleryCount = () => {
      if (!mobile) return;
      const dots = document.querySelector('.tee-gallery .tee-slider__dots');
      if (!dots) return;
      const items = Array.from(dots.children);
      const idx = items.findIndex((li) => /active|current/.test(li.className) || li.querySelector('[aria-current="true"], .active'));
      const host = dots.parentElement;
      let badge = host.querySelector(':scope > .wh-gal-count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'wh-gal-count'; badge.setAttribute('aria-hidden', 'true'); host.appendChild(badge); }
      const text = (idx > -1 ? idx + 1 : 1) + ' / ' + items.length;
      if (badge.textContent !== text) badge.textContent = text;
    };
    // Schritt 31 (2026-10-20, Lukas): Personalisierer-Leiste mobil. Zone = Formularanfang ist nach oben weggescrollt und der
    // Kaufknopf noch nicht im Bild. Dann bleibt die Concept-Leiste sichtbar (CSS über html.wh-pz-on), die Kopfzeile verschwindet.
    let pzOn = false, pzAfter = false, pzTick = false;
    const pzUpdate = () => {
      pzTick = false;
      const form = document.querySelector('.tee-customize-main-form, .tee-customization-form');
      const actions = document.querySelector('.tee-form-actions');
      let on = false, after = false;
      if (mobile && form && actions) {
        const ft = form.getBoundingClientRect().top, ar = actions.getBoundingClientRect();
        on = ft < 100 && ar.top > innerHeight - 8;
        after = ar.bottom < 0;   // Kaufknopf nach oben weggescrollt: Leiste bleibt (Concept selbst sieht das versteckte Theme-Formular nicht mehr)
      }
      if (on !== pzOn) { pzOn = on; document.documentElement.classList.toggle('wh-pz-on', on); }
      if (after !== pzAfter) { pzAfter = after; document.documentElement.classList.toggle('wh-pz-after', after); }
    };
    const pzRequest = () => { if (!pzTick) { pzTick = true; setTimeout(pzUpdate, 0); } };   // kein rAF: läuft auch in Hintergrund-Tabs
    // Vorschaubild: das gerade sichtbare Galeriebild (Teeinblue erneuert die Mockups nach dem Hochladen)
    const pzPreview = () => {
      if (!mobile) return;
      const media = document.querySelector('product-sticky-form [data-sticky-product-media]');
      if (!media) return;
      if (!media.dataset.whPz) {
        media.dataset.whPz = '1';
        media.setAttribute('role', 'button'); media.setAttribute('tabindex', '0'); media.setAttribute('aria-label', 'Zur großen Vorschau');
        const go = () => { const g = document.querySelector('.tee-gallery, .product__media-wrapper'); if (g) g.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
        media.addEventListener('click', go);
        media.addEventListener('keydown', (event) => { if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); go(); } });
        const first = media.querySelector('img'); if (first) first.loading = 'eager';   // war mobil ausgeblendet und daher nie geladen
      }
      const track = document.querySelector('.tee-gallery .tee-slider__track');
      if (!track) return;
      const sr = track.parentElement.getBoundingClientRect(); const cx = sr.left + sr.width / 2;
      const slides = Array.from(track.querySelectorAll('.tee-slide'));
      const active = slides.find((s) => { const r = s.getBoundingClientRect(); return r.width > 0 && r.left <= cx && r.right >= cx; }) || slides[0];
      // Teeinblue setzt das Mockup aus Ebenen zusammen (Papier, Schatten, Druckfläche mit Foto und Name): das ganze .tee-mockup
      // verkleinert in die Kachel spiegeln, dann zeigt die Kachel wirklich den Entwurf
      const mockup = active && active.querySelector('.tee-mockup');
      if (mockup) {
        const w = mockup.offsetWidth, h = mockup.offsetHeight;
        if (!w || !h) return;
        const sig = w + 'x' + h + '|' + mockup.innerHTML.length + '|' + Array.from(mockup.querySelectorAll('img, [style*="background-image"]')).map((e) => (e.currentSrc || '') + (e.style.backgroundImage || '')).join('|');
        if (media.dataset.whSig === sig) return;
        media.dataset.whSig = sig;
        let host = media.querySelector('.wh-pz-mockhost');
        if (!host) {
          host = document.createElement('div'); host.className = 'wh-pz-mockhost'; host.setAttribute('aria-hidden', 'true');
          host.style.cssText = 'position:absolute;inset:0;overflow:hidden;';
          media.style.position = 'relative'; media.appendChild(host);
          const img = media.querySelector(':scope > img'); if (img) img.style.display = 'none';
        }
        const clone = mockup.cloneNode(true);
        clone.querySelectorAll('[id]').forEach((e) => e.removeAttribute('id'));
        clone.style.cssText = 'position:absolute;left:0;top:0;width:' + w + 'px;height:' + h + 'px;transform:scale(' + (48 / Math.max(w, h)) + ');transform-origin:0 0;pointer-events:none;';
        host.replaceChildren(clone);
        return;
      }
      // ohne Mockup (z. B. Lieblingsbild): sichtbares Bild des aktiven Slides
      const img = active && Array.from(active.querySelectorAll('img')).find((i) => !i.classList.contains('tee-image--loader') && i.currentSrc && !/loading\.svg/.test(i.currentSrc));
      const thumb = media.querySelector(':scope > img');
      if (img && thumb && thumb.dataset.whSrc !== img.currentSrc) { thumb.dataset.whSrc = img.currentSrc; thumb.removeAttribute('srcset'); thumb.removeAttribute('sizes'); thumb.src = img.currentSrc; }
    };
    // Auswahl kurz: „Poster / Ohne Rahmen / A4 (21x29,7 cm)“ → „Poster · A4“, „Poster / Schwarzer Rahmen / A3 (…)“ → „Poster · Schwarz · A3“
    const pzOptions = () => {
      if (!mobile) return;
      const el = document.querySelector('product-sticky-form [data-sticky-product-options]');
      if (!el) return;
      const raw = el.textContent.replace(/\s+/g, ' ').trim();
      if (!raw || el.dataset.whRaw === raw) return;
      const short = raw.replace(/\s*\([^)]*\)/g, '').split(' / ').filter((s) => !/^ohne rahmen$/i.test(s))
        .map((s) => s.replace(/^schwarzer rahmen$/i, 'Schwarz').replace(/^weißer rahmen$/i, 'Weiß').replace(/\s*Rahmen$/i, '').replace('Natur-Holz', 'Natur').replace('Dunkles Holz', 'Dunkel'))
        // 2026-10-26 (Audit Landeseiten): Acrylglas hat keinen Rahmen, Teeinblue liefert „Default“ oder nochmals „Acrylglas“
        .filter((s, i, all) => !/^default$/i.test(s) && all.indexOf(s) === i).join(' · ');
      el.textContent = short;
      el.dataset.whRaw = short;
    };

    const run = () => { placeCountdown(); placePrice(); wrapDescription(); labelSwatches(); updateSticky(); galleryCount(); pzPreview(); pzOptions(); pzRequest(); };
    let timer;
    const start = () => {
      run();
      if (mobile) {
        addEventListener('scroll', pzRequest, { passive: true });
        addEventListener('resize', pzRequest);
        setInterval(pzPreview, 1000);   // Wischen in der Galerie und neue Mockups ändern nur Attribute
      }
      const root = document.querySelector('main') || document.body;
      // Concept lädt den Kaufbereich beim Variantenwechsel neu, daher alles erneut anwenden
      new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(run, 150); }).observe(root, { childList: true, subtree: true });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
